export function normalizeBoundDevices(bindStatus) {
  if (!bindStatus || !bindStatus.bound) return []

  const source = Array.isArray(bindStatus.devices) && bindStatus.devices.length
    ? bindStatus.devices
    : [bindStatus]
  const seen = new Set()

  return source
    .filter(item => item && item.deviceId)
    .filter(item => {
      const deviceId = String(item.deviceId)
      if (seen.has(deviceId)) return false
      seen.add(deviceId)
      return true
    })
    .map(item => ({
      ...item,
      deviceId: String(item.deviceId),
      deviceName: item.deviceName || item.deviceId,
      wecomUserId: item.wecomUserId || '',
      wecomNickname: item.wecomNickname || ''
    }))
}

export function getBoundDeviceLabel(device) {
  if (!device) return ''
  const deviceName = device.deviceName || device.deviceId || '未知设备'
  const accountName = device.wecomNickname || device.wecomUserId || '未登录企微'
  return `${deviceName}（${accountName}）`
}
